import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { BlogContext } from "../../store/BlogContext";

function Blogrightsidebar({ BlogData }) {
    const blogCtx = useContext(BlogContext);

    // Safeguard if BlogData is still loading
    if (!BlogData || !BlogData.Blogs) {
        return <div className="blog-sidebar"><p>Loading recent posts...</p></div>;
    }

    return (
        <div className="blog-sidebar">
            <div className="widget sidebar_widget widget_recent_post mt_60">
                <div className="widget_title">
                    <h3 className="f_p f_size_20 t_color3">Recent posts</h3>
                    <div className="border_bottom"></div>
                </div>
                {BlogData.Blogs.slice(0, 5).map((post) => {
                    return (
                        <div className="media post_item" key={post.id}>
                            <img
                                src={require("../../img/new/blog/" +
                                    post.image +
                                    ".jpg")}
                                alt=""
                                width="100"
                                height="80"
                            />
                            <div className="media-body">
                                <Link
                                    to={`/Blog/${post.slug}`}
                                    onClick={() => {
                                        blogCtx.setBlogPost(
                                            post.title,
                                            post.excerpt, // Updated to pass excerpt/description correctly
                                            post.date,
                                            post.body,
                                            post.image
                                        );
                                    }}
                                >
                                    <h3 className="f_size_16 f_p f_400">
                                        {post.title}
                                    </h3>
                                </Link>
                                <div className="entry_post_info">
                                    By: <span> Admin | </span>
                                    <span>{post.date}</span>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default Blogrightsidebar;